export default __webpack_public_path__ + "static/media/text_bubble_04.177c18a8.png";